import request, { ResponseData, PagerData } from '@/libs/request/request'
import { EpitaphQuery } from 'src/api/epitaph/EpitaphQuery'
import { GenealogyMember } from 'src/api/genealogy/GenealogyMember'

// Epitaph
export type Epitaph = {

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // 生平事迹
  deeds?:string

  // 族谱id
  genealogyId?:number

  // 业务Id
  id?:number

  // 轮播图场景名称
  name?:string

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 标题
  version?:number

  // 族谱成员信息
  genealogyMember?:GenealogyMember

  // 族谱成员id
  memberId?:number

  // 图片(上传路径)
  picture?:string
}

export default class EpitaphService {
  /**
   * 添加一个墓志铭
   * @param {Epitaph} item 墓志铭实体
   **/
  static addOneEpitaph (item?:Epitaph):Promise<ResponseData<Epitaph>> {
    return request<ResponseData<Epitaph>>({
      method: 'POST',
      data: item,
      url: '/admin/Epitaph/Epitaph'
    })
  }

  /**
   * 更新一个墓志铭
   * @param {Epitaph} item 墓志铭实体
   **/
  static updateOneEpitaph (item?:Epitaph):Promise<ResponseData<Epitaph>> {
    return request<ResponseData<Epitaph>>({
      method: 'PUT',
      data: item,
      url: '/admin/Epitaph/Epitaph'
    })
  }

  /**
   * 获取墓志铭的分页列表数据
   * @param {EpitaphQuery} query 墓志铭实体查询条件
   **/
  static getPagesOfEpitaph (query?:EpitaphQuery):Promise<ResponseData<PagerData<Epitaph>>> {
    return request<ResponseData<PagerData<Epitaph>>>({
      method: 'POST',
      data: query,
      url: '/admin/Epitaph/Epitaph/pages'
    })
  }

  /**
   * 通过id获取一个墓志铭
   * @param {number} id 墓志铭id
   **/
  static getOneEpitaph (id:number):Promise<ResponseData<Epitaph>> {
    return request<ResponseData<Epitaph>>({
      method: 'GET',
      url: `/admin/Epitaph/Epitaph/${id}`
    })
  }

  /**
   * 删除一个墓志铭
   * @param {number} id 墓志铭id
   **/
  static deleteOneEpitaph (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/Epitaph/Epitaph/${id}`
    })
  }
}
